import { request } from "./config";

const baseURL = configs.serveBaseURL;
const chatRoomBaseURL = configs.chatRoomServeBaseURL;

function getFullUrl(url, isChatRoom = false) {
  return (isChatRoom ? chatRoomBaseURL : baseURL) + url;
}

// app
export const sessionRegister = (data) =>
  request.post(getFullUrl(`/session/register`), data); //用户注册
export const bindEmail = (data) => request.post(getFullUrl("user/email"), data); //用户绑定邮箱
export const bindEmailCode = (data) => request.post(getFullUrl("user/activate"), data); //用户绑定邮箱验证码
export const sessionActivate = (data) =>
  request.post(getFullUrl(`/session/activate`), data); //用户激活
export const sessionLogin = (data) => request.post(getFullUrl(`/Account/Login`), data); //用户登录
export const sessionForgot_password = (data) =>
  request.post(getFullUrl(`/session/forgot_password`), data); //重置密码，向邮箱发code
export const sessionCheck_email_address = (data) =>
  request.post(getFullUrl(`/session/check_email_address`), data); //重置密码，code验证
export const sessionUpdate_password = (data) =>
  request.post(getFullUrl(`/session/update_password`), data); //重置密码
export const userNickname = (data) => request.post(getFullUrl(`/user/nickname`), data); //修改用户名
export const userInfo = (data) =>
  request.get(getFullUrl("/Account/ReqUserInfo"), { params: data }); //获取用户登录信息

// app-> home
export const GetSystemInfo = (data) =>
  request.get(getFullUrl(`/Home/SystemInfo`), { params: data }); // 首页系统信息（公告、QQ群链接等）
export const indexHistory = (data) =>
  request.get(getFullUrl(`/home/AwardHistory`), { params: data }); //主页箱子抽取历史记录
export const indexHistoryBest = (data) =>
  request.get(getFullUrl(`/home/AwardHistoryBest`), { params: data }); //主页箱子抽取历史记录最佳
export const freeboxInfo = (data) =>
  request.get(getFullUrl(`/home/freeboxInfo`), { params: data }); //主页箱子抽取历史记录

// app -> home -> index
export const boxList = (data) =>
  request.get(getFullUrl(`/home/CaseList`), { params: data }); //箱子列表展示
export const getCaseImgList = (data) =>
  request.get(getFullUrl(`/UserCase/CaseImgList`), { params: data }); //自建箱子-箱子样式列表
export const getCaseItemList = (data) =>
  request.get(getFullUrl(`/UserCase/CaseItemList`), { params: data }); //自建箱子-可选物品列表 cat&minprice&maxprice
export const getCaseItemType = (data) =>
  request.get(getFullUrl(`/UserCase/CaseItemType`), { params: data }); //自建箱子-物品分类列表
export const createUserCase = (data) =>
  request.post(getFullUrl(`/UserCase/Create`), data); //自建箱子-创建 { name, caseImgUrl, defaultRate, items: [{ itemId, dropRate }] }
export const getPublicList = (data) =>
  request.get(getFullUrl(`/UserCase/PublicList`), { params: data }); //自建箱子列表 page、pageSize、keyword
export const getUserCaseConfig = (data) =>
  request.get(getFullUrl(`/UserCase/Config`), { params: data }); //创建盲盒配置（VIP限制等）
export const calculatePrice = (data) =>
  request.post(getFullUrl(`/UserCase/CalculatePrice`), data); //计算开箱售价与收益 { defaultRate, items: [{ itemId, price, dropRate }] }
export const getUserCaseDetail = (id) =>
  request.get(getFullUrl(`/UserCase/Detail/${id}`)); //我创建的箱子详情（banner 用）caseInfo、items
export const getUserCaseUserInfo = (memberId) =>
  request.get(getFullUrl(`/UserCase/GetUserInfo`), { params: { memberId } }); //我创建的箱子-banner 用户信息
export const getUserCasesByMemberId = (memberId, data) =>
  request.get(getFullUrl(`/UserCase/GetUserCasesByMemberId`), { params: { memberId, ...data } }); //我创建的箱子-盲盒卡片列表
export const userCaseOpenCase = (data) =>
  request.post(getFullUrl(`/UserCase/OpenCase`), data); //自建箱子开箱 { id, parentId, count, useHappyCoin }
export const getProfitInfo = () =>
  request.get(getFullUrl(`/UserCase/ProfitInfo`)); //获取自建箱子分成信息
export const withdrawProfit = () =>
  request.post(getFullUrl(`/UserCase/WithdrawProfit`)); //领取自建箱子收益

// VIP
export const getCurrentVipInfo = (data) =>
  request.get(getFullUrl(`/Vip/GetCurrentVipInfo`), { params: data }); //当前VIP信息
export const api_GetVipCases = () =>
  request.get(getFullUrl(`/vip/GetVipCases`)); //获取VIP箱子列表

// app -> home -> indexList
export const api_CaseDetail = (data) =>
  request.get(getFullUrl(`/Home/CaseDetail?id=${data}`)); //箱子内奖品展示
export const history = (data) => request.get(getFullUrl(`/case/history/${data}`)); //箱子抽取历史记录
export const openCase = (data) => request.get(getFullUrl(`/user/open_case/${data}`)); //开箱子
export const caseShot = (data) => request.get(getFullUrl(`/case/shot/${data}`)); //试玩
export const api_SellItem = (data) => request.post(getFullUrl("/Account/SellItem"), data); //奖品折价

// app -> store
export const storeMarket = (data) =>
  request.post(getFullUrl(`/market/${data.size}/${data.current}`), data); //商城列表
export const userBuy = (data) => request.get(getFullUrl(`/user/buy/${data}`)); //购买商品
export const userBuyHistory = (data) =>
  request.get(getFullUrl(`/user/buy/history/${data.size}/${data.current}`)); //获取购买记录

// app -> personalCenter
export const userTradeUrl = (data) =>
  request.post(getFullUrl("/account/SetSteamTradeUrl"), data); //绑定url
export const userTradeUrlCode = (data) =>
  request.post(getFullUrl("/account/SetSteamTradeUrl_code"), data); //绑定url验证码
export const api_SyncSteamUserInfo = (data) =>
  request.post(getFullUrl("/account/SyncSteamUserInfo"), data); //更新Steam信息

export const userBalance = (data) =>
  request.get(getFullUrl(`/Account/MoneyDetail`), { params: data }); //钱包明细
export const api_Coin1Ledger = (data) =>
  request.get(getFullUrl(`/Coin1/Ledger`), { params: data }); //Coin1余额与流水
export const api_Coin1ExchangeCash = (data) =>
  request.post(getFullUrl(`/Coin1/ExchangeCash`), data); //Coin1兑换Cash
export const promoterInvitation = (data) =>
  request.post(getFullUrl("/Account/SetInvitation"), data); //绑定邀请码
export const checkInvitationModify = () =>
  request.get(getFullUrl("/Account/CheckInvitationModify")); //检查邀请码是否可修改
export const api_GetUsdtWithdrawInfo = (data) =>
  request.get(getFullUrl("/Account/UsdtWithdrawInfo"), { params: data }); //USDT提取信息
export const api_BindUsdtAddress = (data) =>
  request.post(getFullUrl("/Account/BindUsdtAddress"), data); //绑定USDT地址
export const api_CreateUsdtWithdraw = (data) =>
  request.post(getFullUrl("/Account/CreateUsdtWithdraw"), data); //申请USDT提取
export const api_GetUsdtWithdrawHistory = (data) =>
  request.get(getFullUrl("/Account/UsdtWithdrawHistory"), { params: data }); //USDT提取历史

// app -> personalCenter -> recaption
export const inventory = (data) =>
  request.get(
    getFullUrl(`/Account/Inventory?size=${data.size}&page=${data.current}&category=${data.category}`)
  ); //仓库饰品
export const userRedeem = (data) =>
  request.post(getFullUrl("/Account/ClientRequestSteamItem"), data); //取回饰品
export const api_ReqItemList = (data) =>
  request.post(getFullUrl("/Account/ReqItemList"), data); //获取取回列表
export const api_PinItem = (data) =>
  request.post(getFullUrl("/Account/TogglePinItem"), data); //锁定饰品
export const setBio = (data) =>
  request.post(getFullUrl("/Account/SetBio"), data); //设置个人简介 { val: "string" }

// app -> personalCenter -> agency
export const agentInfo = (data) => request.get(getFullUrl("/promoter/info")); //获取代理信息
export const promoterCode = (data) => request.post(getFullUrl("/promoter/code"), data); //设置邀请码
export const promoterWithdraw = (data) =>
  request.post(getFullUrl("/promoter/withdraw"), data); //提取佣金
export const promoterWithdrawHistory = (data) =>
  request.post(getFullUrl("/promoter/withdraw_history"), data); //提取记录
export const promoterInfo = (data) => request.post(getFullUrl("/promoter/income"), data); //充值流水
export const promoterInfo2 = (data) => request.post(getFullUrl("/promoter/income_2"), data); //下线返余额
export const rebateInfo = (data) => request.post(getFullUrl("/promoter/rebate"), data); //佣金奖励
export const requestAgent = (data) => request.post(getFullUrl("/promoter/apply"), data); //申请成为代理
export const requestInfo = (data) =>
  request.get(getFullUrl("/promoter/apply_status"), data); //代理信息独取

//汰换合同
export const provideList = (data) =>
  request.get(getFullUrl(`/trade/my_items`), { params: data }); //饰品材料
export const targetList = (data) =>
  request.get(getFullUrl(`/trade/tradeable_items`), { params: data }); //目标材料
export const sureExchange = (data) => request.post(getFullUrl("/trade"), data); //汰换

//福利箱
export const userOpen_cdk = (data) =>
  request.post(getFullUrl(`/Account/OpenCaseCdkey`), data); //开启免费宝箱

export const exchangeHistory = (data) =>
  request.post(getFullUrl("/Account/MixItemLog"), data); //获取汰换历史记录

//获取反水信息
export const RebateDetail = (data) => request.get(getFullUrl("/rebate/RebateDetail")); //获取交易历史记录
export const ClaimRebate = () => request.post(getFullUrl("/rebate/Claim"));

// 世界杯竞猜
export const api_WorldCupCompetitions = () =>
  request.get(getFullUrl("/WorldCup/Competitions"));
export const api_WorldCupMatches = (data) =>
  request.get(getFullUrl("/WorldCup/Matches"), { params: data });
export const api_WorldCupDetail = (id) =>
  request.get(getFullUrl("/WorldCup/Detail"), { params: { id } });
export const api_WorldCupMyBets = (data) =>
  request.get(getFullUrl("/WorldCup/MyBets"), { params: data });
export const api_WorldCupBet = (data) =>
  request.post(getFullUrl("/WorldCup/Bet"), data);

//手机号注册
export const sendMobileCode = (data) =>
  request.post(getFullUrl(`/Account/register_code`), data); //发送手机注册验证码
export const mobileRegisterApi = (data) =>
  request.post(getFullUrl(`/account/Register`), data); //手机号注册
export const sendBindEmailCode = (data) =>
  request.post(getFullUrl(`/account/send_binding_email`), data); //发送绑定邮箱验证码
export const sureBindEmail = (data) => request.post(getFullUrl(`/Account/SetMail`), data); //确认绑定邮箱
export const sendBindPhoneCode = (data) =>
  request.post(getFullUrl(`/account/send_binding_sms`), data); //发送绑定手机号验证码
export const sureBindPhone = (data) => request.post(getFullUrl(`/account/set_phone`), data); //确认绑定手机号
export const sendResetCode = (data) =>
  request.post(getFullUrl(`/account/FoundPass_code`), data); //发送修改密码的手机验证码
export const resetPhonePassword = (data) =>
  request.post(getFullUrl(`/Account/ChangePassword`), data); //修改密码
export const sureBindQQApi = (data) => request.post(getFullUrl(`/Account/SetQQ`), data); //确认绑定QQ
export const send_reset_sign_in_password_code = (data) =>
  request.post(getFullUrl(`/Account/FoundPass_code`), data); //发送手机注册验证码
export const reset_sign_in_password = (data) =>
  request.post(getFullUrl(`/Account/FoundPass`), data); //发送手机注册验证码

//多开箱
export const userOpenMany = (data) => request.post(getFullUrl(`/Account/OpenCase`), data); //多开箱

//roll房
export const roll_list = (data) =>
  request.get(getFullUrl(`/Roll/RoomList`), { params: data });

//获取roll房列表信息
export const crate_roll_room = (data) => request.post(getFullUrl("/UserRoll/AddRollRoom"), data); //创建roll房
export const roll_detail = (data) =>
  request.get(getFullUrl(`/roll/RoomDetail?id=${data.id}`)); //获取roll房明细信息
export const roll_player_page = (data) =>
  request.get(
    getFullUrl(`/roll/RoomMember?id=${data.id}&current=${data.page}&size=${data.size}`)
  ); //获取roll房参与用户分页数据
export const roll_winner_page = (data) =>
  request.get(getFullUrl(`/roll/${data.id}/winners/${data.page}`)); //获取roll房获奖名单分页数据
export const roll_join = (data) => request.post(getFullUrl("/roll/JoinRoom"), data); //加入roll房
export const roll_assets_list = (data) =>
  request.get(getFullUrl(`/roll/assets/${data.page}`)); //获取roll房可添加的饰品信息

export const updateAvatar = () => request.post(getFullUrl("/user/update_avatar")); //更新头像

/** 新汰换 */
export const get_interchange_assets_type = (data) =>
  request.get(getFullUrl(`/Account/ContractItemType`));
export const get_interchange_assets = (data) =>
  request.get(getFullUrl(`/Account/ContractItemList`), { params: data });
export const get_interchange_assets_history = (data) =>
  request.get(getFullUrl("/Account/ContractItemHistory"), { params: data });
export const new_trade_sure = (data) =>
  request.post(getFullUrl(`/Account/ContractUpgradeItem`), data);
export const get_contract_upgrade_fee_rate = () =>
  request.get(getFullUrl(`/Account/ContractUpgradeFeeRate`));

export const api_reqitemlistlog = (data) =>
  request.post(getFullUrl(`/Account/ReqItemList`), data); //获取取回列表

//支付渠道确认
export const api_GetPaymentInfo = (data) =>
  request.post(getFullUrl("/pay/GetPaymentInfo"), data); //获取支付面值
export const api_payCreateOrder = (data) =>
  request.post(getFullUrl("/pay/CreateOrder"), data); //确认支付
export const api_payCreateOrderBySN = (data) =>
  request.post(getFullUrl("/pay/CreateOrderBySN"), data);

export const api_GetPartnerPayDetail = (data) =>
  request.get(
    getFullUrl(`/Account/GetPartnerPayDetail?size=${data.size}&page=${data.current}`)
  ); //钱包明细

export const api_DrawCash = (data) => request.post(getFullUrl("/Account/DrawCash"), data); //确认提现
export const api_DrawCashHistory = (data) =>
  request.get(
    getFullUrl(`/Account/DrawCashHistory?size=${data.size}&page=${data.current}`)
  ); //钱包明细

export const api_GetStoreItemList = (data) =>
  request.get(getFullUrl(`/Store/GetStoreItemList`), { params: data }); //获取商品列表
export const api_StoreBuyItem = (data) =>
  request.post(getFullUrl("/Store/StoreBuyItem"), data); //确认购买

export const GetEventList = (data) =>
  request.get(getFullUrl("/Home/GetEventList"), { params: data }); //确认购买

export const api_SetPromoteCode = (data) =>
  request.post(getFullUrl(`/Account/SetPromoteCode`), data); //修改邀请码
export const api_SetNickname = (data) =>
  request.post(getFullUrl(`/Account/SetNickname`), data); //修改昵称
export const api_UploadAvatar = (data) =>
  request.post(getFullUrl(`/Account/UploadAvatar`), data); //修改头像

//用户充值记录
export const api_GetRechargeList = (data) =>
  request.get(getFullUrl("/account/GetPayList"), { params: data });

//取回历史
export const api_GetReqItemlog = (data) =>
  request.get(getFullUrl("/account/GetReqItemlog"), { params: data });
//开箱历史
export const api_OpenCaseLog = (data) =>
  request.get(getFullUrl("/Account/OpenCaseLog"), { params: data });

//获取对战历史
export const api_CasebattleRoomHistory = (data) =>
  request.get(getFullUrl("/account/CasebattleRoomHistory"), { params: data });
//获取我的对战记录
export const api_MemberCasebattleHistory = (data) =>
  request.get(getFullUrl("/account/MemberCasebattleHistory"), { params: data });
//个人盲盒对战明细和公平性验证参数
export const api_CaseBattleLogDetail = (data) =>
  request.get(getFullUrl("/CaseBattle/LogDetail"), { params: data });
//获取对战房间消息语句
export const api_GetQuickChatPresetTexts = (data) =>
  request.get(getFullUrl("/QuickChatPresetTexts/GetQuickChatPresetTexts", true), { params: data });

//获取红包列表
export const api_GetGiftList = (data) =>
  request.get(getFullUrl("/Gift/GetGiftList"), { params: data });
export const api_ReceiveGift = (data) =>
  request.post(getFullUrl(`/Gift/ReceiveGift`), data); //领取普通红包
export const api_ReceiveGiftCDK = (data) =>
  request.post(getFullUrl(`/Gift/ReceiveGiftCDK`), data); //领取口令红包

export const api_CheckOrder = (data) =>
  request.get(getFullUrl(`/pay/CheckOrder`), { params: data }); //查询充值订单
export const api_AutoAnchorAddBalance = (data) =>
  request.post(getFullUrl(`/pay/AutoAnchorAddBalance`), data); //查询充值订单

//绑定身份证
export const api_BindIdCard = (data) =>
  request.post(getFullUrl(`/account/SetIdCard`), data); //查询充值订单

//获取救援金计算结果
export const api_GetSubsidy = (data) => request.get(getFullUrl("/Gift/GetSubsidy"));

//获取推广相关信息
export const api_GetInviterStats = (data) =>
  request.get(getFullUrl("/account/GetInviterStats"));
//获取推广奖金
export const api_ReceiveInviterBonus = (data) =>
  request.post(getFullUrl("/account/ReceiveInviterBonus"), data);

export const api_GetSubAccount = (data) =>
  request.get(getFullUrl("/Transfer/GetSubAccount"));
export const api_GetSubProfileByUid = (data) =>
  request.get(getFullUrl(`/Transfer/Profile`), { params: data });
export const api_AddSubAccount = (data) =>
  request.post(getFullUrl(`/Transfer/AddSubAccount`), data);
export const api_RemoveSubAccount = (data) =>
  request.delete(getFullUrl(`/Transfer/RemoveSubAccount`), { params: data });
export const api_Transfer = (data) => request.post(getFullUrl(`/Transfer`), data);
export const api_GetC2CTransferLog = (data) =>
  request.get(getFullUrl(`/Transfer/GetC2CTransferLog`), { params: data });
export const api_DoExchange = (data) =>
  request.post(getFullUrl(`/Transfer/DoExchange`), data);

export const api_getCommissionList = (data) =>
  request.get(getFullUrl("/Account/GetCommissionMoneyList"), { params: data });

export const api_withdrawCommission = (data) =>
  request.post(getFullUrl("/Account/PostWithdrawCommission"), data);

export const api_GetAcl = (data) =>
  request.get(getFullUrl("/Home/Acl"), {
    params: {
      siteName: "kjcsgo",
    },
  });

export const api_GetFeatureAccess = () =>
  request.get(getFullUrl("/Home/FeatureAccess"), {
    params: {
      siteName: "kjcsgo",
    },
  });

// 我的排行
export const api_myranking = (data) =>
  request.get(getFullUrl("/Account/myranking"), { params: data });

// 排行榜历史
export const api_RankingEvents = (data) =>
  request.get(getFullUrl("/Account/RankingEvents"), { params: data });

// 公平性验证
export const api_GetSeeds = (data) =>
  request.get(getFullUrl("/Account/GetUserSeeds"), { params: data });
export const api_SaveClientSeed = (data) =>
  request.post(getFullUrl("/Account/SaveClientSeed"), data);
export const api_RegenerateAndGetCurrentServerSeed = (data) =>
  request.post(getFullUrl("/Account/RegenerateAndGetCurrentServerSeed"), data);

// crash欢乐豆记录
export const api_getHldList = (data) =>
  request.get("https://api2.mifa.ltd/api/happy-coin/history", { params: data }); // ?page=0&size=15&type=wheel&start=2024%2F5%2F31

// 获取所有欢乐豆领取方式的状态和奖励信息
export const api_GetAllClaimStatus = (data) =>
  request.get(getFullUrl("/HappyCoin/GetAllClaimStatus"), { params: data });

// 游戏记录列表（分页）pageIndex, pageSize
export const api_GetHappyCoinRewards = (data) =>
  request.get(getFullUrl("/HappyCoin/GetHappyCoinRewards"), { params: data });

// 余额记录列表（分页）pageIndex, pageSize
export const api_GetHappyCoinDetails = (data) =>
  request.get(getFullUrl("/HappyCoin/GetHappyCoinDetails"), { params: data });

// 兑换欢乐豆配置
export const api_GetExchangeConfig = (data) =>
  request.get(getFullUrl("/HappyCoin/GetExchangeConfig"), { params: data || {} });

// 欢乐豆游戏是否累计流水
export const api_GetHappyCoinGameTurnoverSettings = () =>
  request.get(getFullUrl("/HappyCoin/GetGameTurnoverSettings"));

// 欢乐豆兑换余额
export const api_ExchangeToBalance = (data) =>
  request.post(getFullUrl("/HappyCoin/ExchangeToBalance"), data);

// 领取每日欢乐豆（首次登录奖）
export const api_ClaimDailyHappyCoin = (data) =>
  request.post(getFullUrl("/HappyCoin/ClaimDailyHappyCoin"), data || {});

// 在线奖励（每半小时）
export const api_ClaimHalfHourlyHappyCoin = (data) =>
  request.post(getFullUrl("/HappyCoin/ClaimHalfHourlyHappyCoin"), data || {});

// 每日热门时间奖励
export const api_ClaimTimePeriodHappyCoin = (data) =>
  request.post(getFullUrl("/HappyCoin/ClaimTimePeriodHappyCoin"), data || {});

// 欢乐豆连续登录的奖励配置
export const api_ClaimConsecutiveReward = (data) =>
  request.post(getFullUrl("/HappyCoin/ClaimConsecutiveReward"), data);

// 每周奖励（请求/领取）
export const api_ClaimWeeklyHappyCoin = (data) =>
  request.post(getFullUrl("/HappyCoin/ClaimWeeklyHappyCoin"), data || {});

// 每月奖励（请求/领取）
export const api_ClaimMonthlyHappyCoin = (data) =>
  request.post(getFullUrl("/HappyCoin/ClaimMonthlyHappyCoin"), data || {});

// 多人集资开箱列表
export const multiplePeopleCaseRecentList = (data) =>
  request.get(getFullUrl(`/MPC/RecentCases`), { params: data });
//获取历史集资箱子
export const multiplePeopleCaseHistoryList = (data) =>
  request.get(getFullUrl(`/MPC/HistoricalCases`), { params: data });
//获取自己参加的集资箱子
export const multiplePeopleCaseMineList = (data) =>
  request.get(getFullUrl(`/MPC/MyCases`), { params: data });
//获取自己参加的集资箱子
export const getMPCaseSettings = (data) =>
  request.get(getFullUrl(`/MPC/MPCaseSettings`), { params: data });
//获取多人集资箱子详情
export const getMPCaseDetail = (data) =>
  request.get(getFullUrl(`/MPC/CaseDetail?caseId=${data}`));


// 商城余额转到红包余额
export const api_CashToRedPacketBalance = (data) =>
  request.post(getFullUrl(`/RedPacket/CashToRedPacketBalance`), data);
// 红包余额到商城余额
export const api_RedPacketBalanceToCash = (data) =>
  request.post(getFullUrl(`/RedPacket/RedPacketBalanceToCash`), data);
// 红包余额转账
export const api_TransferRedPacketBalance = (data) =>
  request.post(getFullUrl(`/RedPacket/TransferRedPacketBalance`), data);
// 红包明细
export const api_RedPacketBalanceLog = (data) =>
  request.get(getFullUrl(`/RedPacket/RedPacketLog`), { params: data });
// 红包配置
export const api_RedPacketSettings = (data) =>
  request.get(getFullUrl(`/RedPacket/RedPacketSettings`), { params: data });

// 徽章列表
export const api_GetMetalList = (data) =>
  request.get(getFullUrl(`/Metal/GetMetalList `), { params: data });
// 徽章挂载
export const api_ChangeMetal = (data) =>
  request.post(getFullUrl(`/Metal/AssignMetal`), data);
// 徽章卸载
export const api_UnassignMetal = (data) =>
  request.post(getFullUrl(`/Metal/UnassignMetal`), data);

// crash游戏历史记录 
export const getCrashHistory = (data) => request.get(getFullUrl(`/crash/history`, false, true), { params: data });
export const getCrashRound = (data) => request.get(getFullUrl(`/crash/round/${data.id}`, false, true), { params: { currencyType: data.currencyType } });


// chicken-road api

export const chickenRoadGetCurrentGame = (data) => request.get(getFullUrl(`/chicken-road/games/current`, false, true), { params: data });
export const chickenRoadCreateGame = (data) =>
  request.post(getFullUrl(`/chicken-road/games/create`), data);

export const chickenRoadNextStep = (data) =>
  request.post(getFullUrl(`/chicken-road/games/${data.gameId}/step`), data, { params: { currencyType: data.currencyType } });

export const chickenRoadEndGame = (data) =>
  request.post(getFullUrl(`/chicken-road/games/${data.gameId}/end`), data, { params: { currencyType: data.currencyType } });

export const chickenRoadHistoryAll = (data) => request.get(getFullUrl(`/chicken-road/games/all`, false, true), { params: data });
export const chickenRoadHistoryTop = (data) => request.get(getFullUrl(`/chicken-road/games/top`, false, true), { params: data });
export const chickenRoadUserGames = (data) => request.get(getFullUrl(`/chicken-road/games/users/${data.userId}`, false, true), { params: { currencyType: data.currencyType } });
export const chickenRoadConfig = (data) => request.get(getFullUrl(`/chicken-road/games/config`, false, true), { params: data });


export const getWheelHistory = (data) => request.get(getFullUrl(`/wheel/wheel_history`, false, true), { params: data });
export const getWheelRound = (data) => request.get(getFullUrl(`/wheel/wheel_round/${data.id}`, false, true), { params: { currencyType: data.currencyType } });

